// import { Col, Row } from 'react-bootstrap'
// import AddMarqueeMessageTest from './add-marquee_message_test/AddMarqueeMessageTest'
// import MarqueeMessageTableTest from './MarqueeMessageTableTest'
// import { useState } from 'react';

// function TableView() {

//     const [selectedItem, setSelectedItem] = useState(null);
//     const [refreshList, setRefreshList] = useState(false);

//     return (
//         <Row className="gx-2 overflow-y-hidden m-0 p-0">
//             <Col md="4" style={{ borderRight: "1px solid #dee2e6" }} >
//                 <MarqueeMessageTableTest
//                     onSelect={setSelectedItem}
//                     refresh={refreshList}
//                     onAddNew={() => setSelectedItem({})}
//                 />

//             </Col>

//             <Col md="8" >
//                 {selectedItem &&
//                     <AddMarqueeMessageTest
//                         selected={selectedItem}
//                         setSelectedItem={setSelectedItem}
//                         onSuccess={() => {
//                             setRefreshList((p) => !p); // refetch table
//                             setSelectedItem(null);     // clear form
//                         }}
//                     />
//                 }
//             </Col>
//         </Row>
//     )
// }

// export default TableView

import SplitPane from "react-split-pane";
import { useState } from "react";
import AddMarqueeMessageTest from "./add-marquee_message_test/AddMarqueeMessageTest";
import MarqueeMessageTableTest from "./MarqueeMessageTableTest";

function TableView() {
    const [selectedItem, setSelectedItem] = useState(null);
    const [refreshList, setRefreshList] = useState(false);

    return (

        <div style={{ height: "100vh" }}>
            <SplitPane
                split="vertical"
                minSize={520}
                defaultSize="35%"   // your 40% default
                maxSize={1100}
                style={{ position: "relative" }}
            >
                {/* LEFT PANEL */}
                <div style={{ height: "100%", overflow: "auto", borderRight: "1px solid #dee2e6" }}>
                    <MarqueeMessageTableTest
                        onSelect={setSelectedItem}
                        refresh={refreshList}
                        onAddNew={() => setSelectedItem({})}
                    />
                </div>

                {/* RIGHT PANEL */}
                <div style={{ height: "100%", overflow: "auto" }}>
                    {selectedItem && (
                        <AddMarqueeMessageTest
                            selected={selectedItem}
                            setSelectedItem={setSelectedItem}
                            onSuccess={() => {
                                setRefreshList((p) => !p);
                                setSelectedItem(null);
                            }}
                        />
                    )}
                </div>
            </SplitPane>
        </div>
    );
}

export default TableView;
